import { useEffect, useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import {
  AutoComplete,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Tabs,
  Tooltip,
  Typography,
} from 'antd';
import axios from 'axios';
import { BsBox2 } from 'react-icons/bs';

import ProductImage from '../../../components/productImage';
import CabinetMap from '../../../components/map/CabinetMap';
import { toLatLon, toPosition } from '../../../components/map/mapParts';
import SectionCard from '../../../components/sectionCard/SectionCard';
import { fetchAddressUnit, formatAddressResponse } from '../../../utils/addressHelper';
import PPBoxSelection from '../../orderDelivery/Add/components/PPBoxSelection';
import AddressMap from '../components/map/addressMap/AddressMap';
import useAddExpressDeliveryStore from './store';
import { ADDRESS_TAB, DEFAULT_ADDRESS_TAB } from './useOrderTabs';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { confirm } = Modal;

/** Формын талбарууд хэт өргөн дэлгэц дээр тарж харагдахгүй байх хязгаар */
const FORM_MAX_WIDTH = 960;

/** Сонгосон барааны зургийн хэмжээ */
const IMAGE_SIZE = 38;

const Order = ({
  form,
  field,
  order,
  remove,
  /** Хаяг оруулах таб — URL-ийн `?tab=`-аас (Step1, useOrderTabs.js) */
  activeTab = DEFAULT_ADDRESS_TAB,
  onChangeTab,
  onRemoveTab,
}) => {
  const {
    addresses,
    reference,
    products,
    deliveryTime,
    setDeliveryTime,
    setAddresses,
    removeAddress,
    setCustomFields,
    removeCustomFields,
    setAddressDetails,
    setAddressPosition,
    clearAddressDetails,
    removeAddressDetails,
    removeAddressPosition,
    selectedAddresses,
    setSelectedAddress,
    clearSelectedAddress,
    removeSelectedAddress,
  } = useAddExpressDeliveryStore();

  const aimagHotList = addresses[field.name]?.aimagHotList;
  const sumDuuregList = addresses[field.name]?.sumDuuregList;
  const bagHorooList = addresses[field.name]?.bagHorooList;

  const [phoneOptions, setPhoneOptions] = useState([]);
  const [loadingAddressList, setLoadingAddressList] = useState(null);
  const [selectedDeliveryType, setSelelctedDeliveryType] = useState(
    form.getFieldValue(['orders', field.name, 'deliveryType']) || 'delivery'
  );
  const [selectedLocker, setSelectedLocker] = useState(null);
  const formValues = form.getFieldsValue()?.orders;
  const selectedBagHoroo = formValues?.length && formValues?.[field.name]?.bagHoroo;
  const [selectedBox, setSelectedBox] = useState(null);
  const product = order?.size
    ? (products || []).find((el) => el?.attributes?.size === order.size)
    : null;

  const deliveryType = reference?.deliveryType;

  const onPPBoxChange = async (box) => {
    setSelectedBox(box);
    const address = box?.address?.reduce((group, item) => {
      if (item.type === 'sumduureg' || item.type === 'baghoroo' || item.type === 'aimaghot') {
        group.push(item);
      }
      return group;
    }, []);
    // GeoJSON нь [уртраг, өргөрөг] дараалалтай, store нь [өргөрөг, уртраг] хүлээнэ
    const position = toPosition(toLatLon(box?.location?.coordinates));
    if (position) setAddressPosition(field.name, position);
    await fetchAndSetAddressList(address);
    setAddressDetails(field.name, `${box?.addressName}, ${box?.code}`);
    setDeliveryAddressFromMapInFormField(address);
  };

  const onDeliveryLocationChange = async (selected) => {
    const address = selected?.address;
    /**
     * Байрлалыг `[өргөрөг, уртраг]` болгож хадгална. `Object.values(location)`
     * байсан нь талбарын эрэмбээс хамаардаг, координат байхгүй үр дүн дээр
     * алдаа шиддэг тул СОНГОЛТ БҮХЭЛДЭЭ хадгалагдахгүй байв.
     */
    const position = toPosition(selected?.location);
    if (position) setAddressPosition(field.name, position);
    setAddressDetails(field.name, selected?.name);
    // Алхам солиод буцаж ирэхэд сонголт нь тэмдэглэгдсэн хэвээр байхын тулд
    setSelectedAddress(field.name, selected);
    await fetchAndSetAddressList(address);
    setDeliveryAddressFromMapInFormField(address);
  };

  const setDeliveryAddressFromMapInFormField = (addresses) => {
    //addresses [{type: aimaghot},{type: sumduureg},{type: baghoroo}]
    for (const address of addresses) {
      const type = address.type;
      const addressId = String(address.addressId);
      switch (type) {
        case 'aimaghot':
          setFieldValue('aimagHot', addressId);
          break;
        case 'sumduureg':
          setFieldValue('sumDuureg', addressId);
          break;
        case 'baghoroo':
          setFieldValue('bagHoroo', addressId);
          break;
        default:
          break;
      }
    }
  };

  const fetchAndSetAddressList = async (addressList = []) => {
    // эхний mount дээр аймаг хотын лист авах
    if (addressList[0] == null) {
      await fetchAddressUnit().then(async (res) => {
        const addressList = formatAddressResponse(res?.docs);
        setAddresses(field.name, 'aimagHotList', addressList);
        await fetchAddressUnit(addressList[14].addressId).then(async (res) => {
          const sumDuureg = formatAddressResponse(res?.docs);
          setAddresses(field.name, 'sumDuuregList', sumDuureg);
          await fetchAddressUnit(sumDuureg[0].addressId).then((res) => {
            const bagHoroo = formatAddressResponse(res?.docs);
            setAddresses(field.name, 'bagHorooList', bagHoroo);
          });
        });
      });
      return;
    }
    const data = await fetchAddressUnit();
    const aimagAll = formatAddressResponse(data?.docs);

    for (const address of addressList) {
      const addressId = String(address?.addressId);
      const type = address?.type;

      fetchAddressUnit(addressId).then((data) => {
        const addressList = formatAddressResponse(data?.docs);

        switch (type) {
          case 'aimaghot':
            setAddresses(field.name, 'sumDuuregList', addressList);
            break;
          case 'sumduureg':
            setAddresses(field.name, 'bagHorooList', addressList);
            break;
          case 'baghoroo':
            setAddresses(field.name, 'aimagHotList', aimagAll);
            break;
          default:
            break;
        }
      });
    }
  };

  useEffect(() => {
    if (!addresses[field.name]) {
      const addressIds = [order?.aimagHot, order?.sumDuureg, order?.bagHoroo].filter(
        (item) => item
      );

      addressIds.length === 0 && addressIds.push(null);
      fetchAndSetAddressList(addressIds);
    }
    // fetchAndSetAddressList нь addresses-ыг өөрчилдөг тул deps-д оруулбал
    // давталтад орно. Зөвхөн mount дээр хаягийн жагсаалтыг бэлдэнэ.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabChange = (tab) => {
    fetchAndSetAddressList([null]);
    onChangeTab?.(tab);
  };

  const onRemoveDelivery = () => {
    confirm({
      title: 'Та захиалгыг устгахдаа итгэлтэй байна уу?',
      okText: 'Тийм',
      cancelText: 'Үгүй',
      onOk: () => {
        const key = field.name;
        remove(key);
        removeAddress(key);
        removeCustomFields(key);
        removeAddressDetails(key);
        removeAddressPosition(key);
        removeSelectedAddress(key);
        // URL-д хадгалсан табуудыг мөн ахиулна (дараагийн захиалгын таб зөрөхгүй)
        onRemoveTab?.();
      },
    });
  };

  const handleChangeAddress = (type, value) => {
    setCustomFields(field.name, []);
    clearAddressDetails(field.name);
    clearSelectedAddress(field.name);
    // Дараагийн түвшний жагсаалт ачаалж байгааг тухайн Select дээр харуулна
    setLoadingAddressList(type === 'aimagHot' ? 'sumDuureg' : 'bagHoroo');
    fetchAddressUnit(value)
      .then((res) => {
        const addressList = formatAddressResponse(res?.docs);

        if (type === 'aimagHot') {
          setAddresses(field.name, 'sumDuuregList', addressList);
          setFieldValue('sumDuureg', undefined);
          setAddresses(field.name, 'bagHorooList', []);
          setFieldValue('bagHoroo', undefined);
        }
        if (type === 'sumDuureg') {
          setAddresses(field.name, 'bagHorooList', addressList);
          setFieldValue('bagHoroo', undefined);
        }
      })
      .finally(() => setLoadingAddressList(null));
  };

  const setFieldValue = (fieldName, value) => {
    let orders = form.getFieldValue('orders');
    orders[field.name][fieldName] = value;
    form.setFieldsValue({ orders });
  };

  const handleChangePhoneNumber = (val) => {
    if (val?.length === 4 || phoneOptions.length > 0) {
      searchClient(val);
    }
  };

  const searchClient = (phone) => {
    axios
      .post('/api/v1/merchant-customer/search', {
        phoneNumber: phone,
      })
      .then(({ data }) => {
        if (data.statusCode === 200 && data.result?.length > 0) {
          setPhoneOptions(
            data.result.map((item) => ({
              ...item,
              label: item.phoneNumber,
              value: item.phoneNumber,
              customer: item,
            }))
          );
        } else {
          setPhoneOptions([]);
        }
      });
  };

  const onSelectPhoneNumber = async (val, option) => {
    const address = option.address ?? [];
    await fetchAndSetAddressList(address);

    let orders = form.getFieldValue('orders');

    orders[field.name].firstName = option?.name;
    orders[field.name].email = option?.email;
    orders[field.name].aimagHot = address.find((a) => a.type === 'aimaghot')?.addressId;
    orders[field.name].sumDuureg = address.find((a) => a.type === 'sumduureg')?.addressId;
    orders[field.name].bagHoroo = address.find((a) => a.type === 'baghoroo')?.addressId;

    form.setFieldsValue({ orders });
  };

  const onChangeDeliveryType = (type) => {
    setSelelctedDeliveryType(type);
    setDeliveryTime(type);
  };

  const getCabinets = (type) => {
    setFieldValue('dropoffDate', undefined);
    setFieldValue('deliveryPositionCode', undefined);
    setFieldValue('pricingCode', undefined);

    const orders = form.getFieldValue('orders');
    const order = orders[field.name];
    const addressId = order.bagHoroo ?? 110101;

    axios
      .get(`/api/v1/request/getHubAndCabinet?addressId=${addressId}&deliveryType=${type}`)
      .then(({ data }) => {
        data?.statusCode === 200
          ? setCustomFields(field.name, data.result.data)
          : setCustomFields(field.name, []);
      });
  };

  const isExpress = deliveryTime === 'express';

  const tabItems = [
    {
      key: ADDRESS_TAB.MAP,
      label: 'Газрын зураг',
      children: (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          {selectedDeliveryType === 'deliverytocabinet' ? (
            <CabinetMap
              selectedLocker={selectedLocker}
              setSelectedLocker={setSelectedLocker}
              selectedBox={selectedBox}
              setSelectedBox={onPPBoxChange}
            />
          ) : (
            <AddressMap
              setAddress={onDeliveryLocationChange}
              selectedAddress={selectedAddresses[field.name]}
              type="direct-delivery"
            />
          )}

          {selectedDeliveryType === 'delivery' && (
            <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
              <Col xs={24} md={16} xl={12}>
                <Form.Item
                  {...field}
                  label="Дэлгэрэнгүй хаяг"
                  name={[field.name, 'deliveryDetail']}
                  rules={[{ required: false, message: 'Дэлгэрэнгүй хаягаа оруулна уу!' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Давхар, тоот гэх мэт" />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Space>
      ),
    },
  ];

  tabItems.push({
    key: ADDRESS_TAB.DETAIL,
    label: 'Гараас бичих',
    children: (
      <Space direction="vertical" size={0} style={{ width: '100%' }}>
        <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хот/Аймаг"
              name={[field.name, 'aimagHot']}
              rules={[{ required: true, message: 'Хот/Аймаг сонгоно уу!' }]}
            >
              <Select
                placeholder="Сонгох"
                onChange={(value) => handleChangeAddress('aimagHot', value)}
              >
                {(aimagHotList ?? []).map((unit) => (
                  <Option key={unit?.addressId} value={unit?.addressId}>
                    {unit?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Дүүрэг/Сум"
              name={[field.name, 'sumDuureg']}
              rules={[{ required: true, message: 'Дүүрэг/Сум сонгоно уу!' }]}
            >
              <Select
                placeholder="Сонгох"
                onChange={(value) => handleChangeAddress('sumDuureg', value)}
                loading={loadingAddressList === 'sumDuureg'}
              >
                {(sumDuuregList ?? []).map((unit) => (
                  <Option key={unit?.addressId} value={unit?.addressId}>
                    {unit?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хороо/Баг"
              name={[field.name, 'bagHoroo']}
              rules={[{ required: true, message: 'Хороо/Баг сонгоно уу!' }]}
            >
              <Select
                placeholder="Сонгох"
                loading={loadingAddressList === 'bagHoroo'}
                onChange={() => {
                  setCustomFields(field.name, []);
                  clearAddressDetails(field.name);
                  clearSelectedAddress(field.name);
                  getCabinets(selectedDeliveryType);
                }}
              >
                {(bagHorooList ?? []).map((unit) => (
                  <Option key={unit?.addressId} value={unit?.addressId}>
                    {unit?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {selectedDeliveryType === 'delivery' && !isExpress && (
          <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
            <Col xs={24} md={16} xl={12}>
              <Form.Item
                {...field}
                label="Дэлгэрэнгүй хаяг"
                name={[field.name, 'deliveryDetail']}
                rules={[{ required: false, message: 'Дэлгэрэнгүй хаягаа оруулна уу!' }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Давхар, тоот гэх мэт" />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Space>
    ),
  });

  return (
    <SectionCard
      icon={<BsBox2 />}
      title={`Захиалга №${field.name + 1}`}
      action={
        <Tooltip title="Захиалгыг устгах">
          <Button type="text" danger icon={<DeleteOutlined />} onClick={onRemoveDelivery} />
        </Tooltip>
      }
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хэрэглэгчийн нэр"
              name={[field.name, 'firstName']}
              rules={[{ required: true, message: 'Нэрээ оруулна уу!' }]}
              style={{ marginBottom: 0 }}
            >
              <Input placeholder="Нэр" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хэрэглэгчийн утас"
              name={[field.name, 'phoneNumber']}
              rules={[
                { required: true, message: 'Утасны дугаараа оруулна уу!' },
                { pattern: /^\d{8}$/, message: '8 оронтой дугаар оруулна уу.' },
              ]}
              style={{ marginBottom: 0 }}
            >
              <AutoComplete
                maxLength={8}
                onChange={handleChangePhoneNumber}
                placeholder="Утас"
                options={phoneOptions}
                onSelect={onSelectPhoneNumber}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хэрэглэгчийн мэйл"
              name={[field.name, 'email']}
              rules={[
                { required: true, message: 'Мэйл хаягаа оруулна уу!' },
                { type: 'email', message: 'Имэйл хаяг буруу байна.' },
              ]}
              style={{ marginBottom: 0 }}
            >
              <Input placeholder="И-мэйл" type="email" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }} align="bottom">
          <Col xs={18} sm={9} xl={6}>
            <Form.Item
              {...field}
              label="Барааны хэмжээ"
              name={[field.name, 'size']}
              rules={[{ required: true, message: 'Барааны хэмжээг сонгоно уу!' }]}
              style={{ marginBottom: 0 }}
            >
              <Select placeholder="Барааны хэмжээ">
                {(products || []).reverse().map((item) => (
                  <Option key={item?.productSku} value={item?.attributes?.size}>
                    {item?.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* Сонгосон хэмжээний зураг — талбарын хажууд, доод шугамаар нь тэгшилнэ */}
          <Col flex="none">
            <ProductImage
              src={product?.imageCover}
              alt={product?.title ?? ''}
              size={IMAGE_SIZE}
              preview={Boolean(product?.imageCover)}
              style={{
                objectFit: 'contain',
                background: '#fff',
                border: '1px solid #f1f2f4',
                borderRadius: 6,
                padding: 2,
              }}
            />
          </Col>

          <Col xs={24} sm={12} xl={8}>
            <Form.Item
              {...field}
              label="Хүргэлтийн төрөл"
              name={[field.name, 'deliveryType']}
              rules={[{ required: true, message: 'Хүргэлтийн төрөл сонгоно уу!' }]}
              style={{ marginBottom: 0 }}
            >
              {/* Утгыг Form.Item хариуцна — `value` дарж бичвэл сэргээсэн сонголт харагдахгүй */}
              <Select placeholder="Сонгох" onChange={onChangeDeliveryType}>
                {deliveryType?.type
                  ?.filter((type) => type !== 'deliveryselfproclaim')
                  ?.map((type) => {
                    const item = deliveryType?.detail[type];
                    return (
                      <Option key={type} value={type} label={item}>
                        {item}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <div>
          <Text strong>Хүлээж авах хаяг</Text>
          <Tabs
            activeKey={activeTab}
            onChange={onTabChange}
            items={tabItems}
            size="small"
            style={{ marginTop: 4 }}
          />
        </div>

        {deliveryTime === 'regular' &&
          activeTab !== ADDRESS_TAB.MAP &&
          selectedDeliveryType === 'deliverytocabinet' && (
            <PPBoxSelection
              committeeId={selectedBagHoroo}
              selectedBox={selectedBox}
              setSelectedBox={onPPBoxChange}
            />
          )}

        <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
          <Col xs={24} md={16} xl={12}>
            <Form.Item
              {...field}
              name={[field.name, 'orderDescription']}
              label="Нэмэлт тэмдэглэл"
              style={{ marginBottom: 0 }}
            >
              <TextArea rows={4} placeholder="Энд бичих" />
            </Form.Item>
          </Col>
        </Row>
      </Space>
    </SectionCard>
  );
};

export default Order;
